import React, {
  act,
  forwardRef,
  useContext,
  useEffect,
  // useImperativeHandle,
  useRef,
  useState,
} from "react";
import "./dropdowns.css";
import searchIcon from "../../assets/Icons/search_icon.svg";
import { Close, KeyboardArrowDown } from "@mui/icons-material";
import { Checkbox, Popover, Tooltip } from "@mui/material";
import { validateDropdownOption } from "../../modules/ConfigurationModule/services/PartsConfigurationService";
import { getDropdownData } from "../../services/dropdownsConfigService";
import { useDropdownGlobalData } from "../../contexts/DropdownGlobalDataContext";
import { FixedSizeList } from "react-window";
import { environment } from "../../environments/environment";
import { DialogContext } from "../../contexts/DialogContext";
import { ChangeMeasurementSystemAlertMessage } from "../../modules/ConfigurationModule/components/ChangeMeasurementSytemAlertMessage/ChangeMeasurementSystemAlertMessage";
import { use } from "react";
// import { DropdownGlobalDataContext } from "../../contexts/DropdownGlobalDataContext";
export const Dropdowns = ({
  data = {},
  currentIndexTab,
  updateDropdown,
  resetDropdownsReload,
  onOptionSelect,
  onAllOptionsSelected,
  preSelectValue,
  preSelectOption,
  fixedLabel,
  required,
  onApplySelection,
  disabled,
  hideWhenDisabled,
  context,
  parentComponentId = null,
  externalOpening = false,
  activateErrorHint = false,
  display2Grid = false,
  children,
  clearLabel,
  handleClear,
  display1Grid = false,
  isStatic = false,
  staticData = [],
  staticDataColumnPreselection,
  dropdownFilters,
  showWarningModal = false,
  warningMessagge,
  parameters,
  hideLabel,
  hideRequiredLabel,
  optionLabel,
  onOptionsChange,
  disableMaxWidth,
  selectionLabel,
  placeholder = false,
  preventSelectionWithPreselect = true,
  forceDependency,
  iconPrefix,
  orderFn,
  filterFn,
  deleteSingleOption,
  columnSingleDelete,
  optionsSelectedColumnName,
  clearExternalFilters = null,
  resetId,
  clearAllDropdowns,
  overrideLabel
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const [filterData, setFilterData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filtersOptionsSelected, setFilterOptionsSelected] = useState([]);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [hiddenCount, setHiddenCount] = useState(0);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [labelsToShow, setLabelsToShow] = useState([]);
  const [primaryLabel, setPrimaryLabel] = useState(null);
  const [secondaryLabel, setSecondaryLabel] = useState(null);
  const containerRef = useRef(null);
  const activeOptionRef = useRef(null);
  const [touched, setTouched] = useState(null);
  const [errorLabel, setErrorLabel] = useState("");
  const { updatedropdownDataContext } = useDropdownGlobalData();
  const { openDialog, closeDialog } = useContext(DialogContext);
  const didMount = useRef(false);
  const openWarningDialog = (option, index) => {
    openDialog({
      component: ChangeMeasurementSystemAlertMessage,
      props: {
        onClose: closeDialog,
        continueSelection: () => {
          selectFilterOption(option, index, false, false, false);
          closeDialog();
        },
        warningDesc: warningMessagge,
      },
    });
  };

  useEffect(() => {
    onOptionsChange?.(filterData);
  }, [filterData]);

  const selectFilterOption = (
    option,
    index,
    preventSelectionEvent = false,
    toggle = false,
    showModal = showWarningModal,
    isPreselection = false,
    updateIndex = true
  ) => {
    if (showModal && !isPreselection) {
      openWarningDialog(option, index);
    } else {
      if (data.dropdownType === "Multiple Selection") {
        if (option) {
          if (toggle) {
            let selectedOption = filtersOptionsSelected.find(
              (opt) => opt.id === option.id
            );
            if (selectedOption) {
              clearOneOptionFilter(selectedOption);
              if (!preventSelectionEvent && onAllOptionsSelected) {
                onAllOptionsSelected(
                  filtersOptionsSelected.filter((opt) => opt.id !== option.id)
                );
              }
              return;
            }
          }

          setFilterOptionsSelected((currentElements) => {
            const hasDuplicated = currentElements.some((item) =>
              !isStatic
                ? item[primaryLabel] === option[primaryLabel]
                : item.name === option.name
            );

            if (!hasDuplicated) {
              const updatedOptions = [...currentElements, option];

              data.dependencies.forEach((dependency) => {
                const parentValues = updatedOptions.map((item) => ({
                  [dependency.parentSqlstatementColumnName]:
                    item[dependency.parentSqlstatementColumnName],
                }));

                if (updateDropdown) {
                  updateDropdown(
                    dependency.childDropdownId,
                    parentValues,
                    data.dependencies
                  );
                }
              });

              showSelectionsInLabel(updatedOptions);
              if (!preventSelectionEvent && onOptionSelect) {
                onOptionSelect(option, data.selectedColumn);
              }

              if (!preventSelectionEvent && onAllOptionsSelected) {
                onAllOptionsSelected(updatedOptions);
              }
              setTimeout(() => {
                setGlobalDataOfDropdown(updatedOptions);
              }, 200);
              return updatedOptions;
            }

            return currentElements;
          });
        } else {
          setFilterOptionsSelected([]);
          showSelectionsInLabel([]);
        }
      } else {
        //arn('else 183');
        if (option) {
          setFilterOptionsSelected(() => {
            const updatedOption = [option];

            showSelectionsInLabel(updatedOption);
            if (!preventSelectionEvent && onOptionSelect) {
              onOptionSelect(option, data.selectedColumn);
            }

            setTimeout(() => {
              setGlobalDataOfDropdown(updatedOption);
            }, 200);

            data.dependencies.forEach((dependency) => {
              const parentValues = [
                {
                  [dependency.parentSqlstatementColumnName]:
                    option[dependency.parentSqlstatementColumnName],
                },
              ];
              if (updateDropdown) {
                updateDropdown(
                  dependency.childDropdownId,
                  parentValues,
                  data.dependencies
                );
              }
            });
            return updatedOption;
          });

          if (!preventSelectionEvent) setIsOpen(false);
        } else {
          setFilterOptionsSelected([]);
          showSelectionsInLabel([]);
          setTimeout(() => {
            data.dependencies.forEach((dependency) => {
              const { childDropdownId, parentSqlstatementColumnName } =
                dependency;

              const filteredDependencies = [
                {
                  ...dependency,
                  value: filtersOptionsSelected.map(
                    (item) => item[parentSqlstatementColumnName]
                  ),
                },
              ];

              if (updateDropdown) {
                updateDropdown(
                  childDropdownId,
                  filteredDependencies,
                  data.dependencies
                );
              }
            });
          });
        }
      }
    }
    if (updateIndex) {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    if (isOpen && touched === null) setTouched(false);
    if (!isOpen && touched === false) setTouched(true);
  }, [isOpen, touched]);

  useEffect(() => {
    if (touched && required) {
      if (visibleOptions.length < 1) {
        setErrorLabel("Required");
      } else {
        setErrorLabel("");
      }
    }
  }, [touched, visibleOptions, required]);

  useEffect(() => {
    if (activateErrorHint && required && filtersOptionsSelected.length === 0) {
      setErrorLabel("Required");
    } else {
      setErrorLabel("");
    }
  }, [activateErrorHint, required, filtersOptionsSelected]);

  useEffect(() => {
    if (clearExternalFilters) {
      clearAllFilters();
    }
  }, [clearExternalFilters]);

  const setGlobalDataOfDropdown = (values) => {
    const dropdownData = {
      dropdownName: data.name,
      dropdownDescription: data.description,
      dropdownId: data.id,
      dropdownType: data.dropdownType,
      dropdownVersion: data.version,
      dropdownStatus: data.status,
      ValuesSelected: values,
    };

    updatedropdownDataContext(dropdownData);
  };

  const toggleMenu = (e) => {
    if (e) menuRef.current = e.currentTarget;
    setIsOpen((prev) => !prev);
  };

  const clearAllFilters = () => {
    setFilterOptionsSelected(() => {
      const updatedData = [];
      showSelectionsInLabel(updatedData);
      if (onAllOptionsSelected) {
        onAllOptionsSelected(updatedData);
      }
      handleClear?.();

      return updatedData;
    });
  };

  const clearOneOptionFilter = (option, externalDelete = false) => {
    if (externalDelete) {
      setFilterOptionsSelected((prevData) => {
        const updatedData = prevData.filter(
          (e) => e[columnSingleDelete] !== option
        );
        showSelectionsInLabel(updatedData);
        if (onAllOptionsSelected) {
          onAllOptionsSelected(updatedData);
        }
        return updatedData;
      });
    } else {
      setFilterOptionsSelected((prevData) => {
        const updatedData = prevData.filter((e) => e !== option);
        showSelectionsInLabel(updatedData);
        if (onAllOptionsSelected) {
          onAllOptionsSelected(updatedData);
        }
        return updatedData;
      });
    }
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      // setIsOpen(false);
    }
  };

  const handleInputChange = (event) => {
    setFilterSearchTerm(event.target.value);
  };

  const applySelection = (filtersOptionSelected) => {
    onApplySelection?.(filtersOptionSelected);
  };

  const showSelectionsInLabel = (options) => {
    //console.warn('show selections in label', options);
    if (options) {
      const container = document.getElementById(
        "selected-options-container-dropdown"
      );
      if (!container) return;
      //console.warn('container found');

      const containerWidth = container.offsetWidth;
      let currentWidth = 0;
      let visibleItemsCount = 0;
      const visibleOptions = [];

      options.forEach((option) => {
        const tempOption = document.createElement("span");
        tempOption.style.visibility = "hidden";
        tempOption.style.position = "absolute";
        tempOption.textContent = optionsSelectedColumnName
          ? option[optionsSelectedColumnName]
          : option[primaryLabel];
        container.appendChild(tempOption);

        const spanWidth = tempOption.getBoundingClientRect().width;
        container.removeChild(tempOption);

        switch (data.dropdownType) {
          case "Multiple Selection":
            if (currentWidth + spanWidth <= containerWidth) {
              currentWidth += spanWidth;
              visibleItemsCount++;
              visibleOptions.push(option);
            }
            break;
          case "Single Selection":
            visibleOptions.push(option);
            break;
        }
      });
      //console.warn('calculated options', options, data.dropdownType, visibleOptions);

      const hiddenCount = options.length - visibleItemsCount;
      setHiddenCount(hiddenCount);
      setVisibleOptions(visibleOptions);
    } else {
      setVisibleOptions([]);
    }
  };

  const getDropDownData = async (
    page,
    pageSize,
    isSearch = false,
    reload = false
  ) => {
    if (isStatic === true) {
      return;
    }

    const filterId = data.id;
    let updatedDependencies = [];
    if (forceDependency != null) {
      updatedDependencies = forceDependency;
    } else {
      updatedDependencies = data.dependenciesToUpdate
        ? data.dependenciesToUpdate
            .filter((dep) => dep.childDropdownId === filterId)
            .map((dep) => ({
              ...dep,
              value: data.parentValues.map(
                (val) => val[dep.parentSqlstatementColumnName]
              ),
            }))
        : [];
    }
    try {
      setLoading(true);
      let request;
      if (
        page === 0 &&
        !reload &&
        debouncedSearchTerm === "" &&
        context?.dropdownDefaultOptions?.[data.id]?.length > 0
      ) {
        request = {
          data: {
            responseCode: 200,
            load: context?.dropdownDefaultOptions?.[data.id] ?? [],
          },
        };
      } else {
        request = await getDropdownData(
          filterId,
          debouncedSearchTerm,
          updatedDependencies,
          page,
          pageSize,
          parentComponentId,
          dropdownFilters ? dropdownFilters : [],
          parameters ? parameters : []
        );
      }

      if (request.data.responseCode === 200) {
        if (isSearch) {
          setFilterData(
            filterFn
              ? (orderFn
                  ? request.data.load?.toSorted?.(orderFn)
                  : request.data.load
                ).filter(filterFn)
              : orderFn
              ? request.data.load?.toSorted?.(orderFn)
              : request.data.load
          );
          setTotalRecords(request.data.totalRecords);
          setPage(1);

          //search;
        } else {
          // New Page
          setFilterData((prevData) => {
            // const updatedData = [...prevData, ...request.data.load.filter(option => !prevData.some(prevOption => prevOption.id === option.id))];
            const updatedData = filterFn
              ? (orderFn
                  ? [...prevData, ...request.data.load].toSorted(orderFn)
                  : [...prevData, ...request.data.load]
                ).filter(filterFn)
              : orderFn
              ? [...prevData, ...request.data.load].toSorted(orderFn)
              : [...prevData, ...request.data.load];
            return updatedData;
          });

          setTotalRecords(request.data.totalRecords);
          setPage((prevPage) => prevPage + 1);
        }

        if (data.firstRecordSelection) {
          selectFilterOption(request.data.load[0], 0, false, true);
          if (resetDropdownsReload) {
            resetDropdownsReload();
          }
        }

        if (data.oneRecAutoSelection) {
          if (filterData.length == 1) {
            selectFilterOption(request.data.load[0], 0, false, true);
            if (resetDropdownsReload) {
              resetDropdownsReload();
            }
          }
        }

        if (resetDropdownsReload) {
          resetDropdownsReload();
        }
      } else {
        // error
        setFilterData([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error(`Error fetching dropdown ${data.name} data:`, error);
    } finally {
      setLoading(false);
    }
  };

  const loadMoreItems = () => {
    if (loading || filterData.length >= totalRecords) {
      return;
    }
    getDropDownData(page, 200);
  };

  useEffect(() => {
    if (deleteSingleOption != null) {
      clearOneOptionFilter(deleteSingleOption, true);
    }
  }, [deleteSingleOption]);

  useEffect(() => {
    if (isStatic) {
      setFilterData(staticData);
      setTotalRecords(staticData.length);
    } else {
      if (data && data.id) {
        getDropDownData(0, 200, true);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    // window.addEventListener("resize", applySelection(filtersOptionsSelected));

    return () => {
      // window.removeEventListener(
      //   "resize",
      //   applySelection(filtersOptionsSelected)
      // );
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (typeof preSelectOption?.id === "number") {
      setVisibleOptions([preSelectOption]);
    }
  }, [preSelectOption]);

  // useEffect(() => {
  //   if (preSelectValue !== null && preSelectValue !== undefined) {
  //     if (!isStatic) {
  //       validateDropdownOption(data.id, preSelectValue, parameters).then(
  //         (response) => {
  //           if (response.data.responseCode === 200) {
  //             if (response.data.load?.[0]) {
  //               const optionIndex = filterData.findIndex(
  //                 (e) =>
  //                   e[data.selectedColumn] ===
  //                   response.data.load[0][data.selectedColumn]
  //               );
  //               selectFilterOption(
  //                 response.data.load[0],
  //                 optionIndex,
  //                 preventSelectionWithPreselect,
  //                 false,
  //                 false,
  //                 true
  //               );
  //             }
  //           }
  //         }
  //       );
  //     } else {
  //       let optionIndex = staticData.findIndex(
  //         (e) => e[staticDataColumnPreselection] === preSelectValue
  //       );

  //       if (optionIndex !== -1) {
  //         let optionSelected = staticData[optionIndex];
  //         selectFilterOption(
  //           optionSelected,
  //           optionIndex,
  //           preventSelectionWithPreselect,
  //           false,
  //           false,
  //           true
  //         );
  //       }
  //     }
  //   }

  //   if (preSelectValue === null) {
  //     clearAllFilters();
  //   }
  // }, [preSelectValue, filterData]);
  
// useEffect(() => {
//   if (preSelectValue !== null && preSelectValue !== undefined) {
//     const valuesArray = Array.isArray(preSelectValue)
//       ? preSelectValue
//       : [preSelectValue];

//     if (!isStatic) {
//       Promise.all(
//         valuesArray.map((val) =>
//           validateDropdownOption(data.id, val, parameters , data.selectedColumn)
//         )
//       ).then((responses) => {
//         responses.forEach((response) => {
//           if (
//             response.data.responseCode === 200 &&
//             response.data.load?.[0]
//           ) {
//             const optionIndex = filterData.findIndex(
//               (e) =>
//                 e[data.selectedColumn] ===
//                 response.data.load[0][data.selectedColumn]
//             );
//             selectFilterOption(
//                 response.data.load[0],
//                 optionIndex,
//                 preventSelectionWithPreselect,
//                 false,
//                 false,
//                 true
//               );
//           }
//         });
//       });
//     } else {
//       valuesArray.forEach((val) => {
//         const optionIndex = staticData.findIndex(
//           (e) => e[staticDataColumnPreselection] === val
//         );
//         if (optionIndex !== -1) {
//           const optionSelected = staticData[optionIndex];
//           selectFilterOption(
//             optionSelected,
//             optionIndex,
//             preventSelectionWithPreselect,
//             false,
//             false,
//             true
//           );
//         }
//       });
//     }
//   }

//   if (preSelectValue === null) {
//     clearAllFilters();
//   }
// }, [preSelectValue, filterData]);

useEffect(() => {
  if (preSelectValue !== null && preSelectValue !== undefined) {
    const valuesArray = Array.isArray(preSelectValue)
      ? preSelectValue
      : [preSelectValue];

    if (!isStatic) {
      Promise.all(
        valuesArray.map((val) =>
          validateDropdownOption(data.id, val, parameters , data.selectedColumn)
        )
      ).then((responses) => {
        // En la parte de la respuesta:
responses.forEach((response, index) => {
  if (response.data.responseCode === 200 && response.data.load?.[0]) {
    // Usar el valor original que enviaste para buscar
    const originalValue = valuesArray[index];
    const optionIndex = filterData.findIndex(
      (e) => e[data.selectedColumn] === originalValue
    );
    
    if (optionIndex !== -1) {
      selectFilterOption(
        filterData[optionIndex],
        optionIndex,
        preventSelectionWithPreselect,
        false,
        false,
        true
      );
    }
  }
});
      });
    } else {
      valuesArray.forEach((val) => {
        const optionIndex = staticData.findIndex(
          (e) => e[staticDataColumnPreselection] === val
        );
        if (optionIndex !== -1) {
          const optionSelected = staticData[optionIndex];
          selectFilterOption(
            optionSelected,
            optionIndex,
            preventSelectionWithPreselect,
            false,
            false,
            true
          );
        }
      });
    }
  }

  if (preSelectValue === null) {
    clearAllFilters();
  }
}, [preSelectValue, filterData]);

  useEffect(() => {
    if (data.reload) {
      getDropDownData(0, 200, true, true);
    }
  }, [data.reload]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    getDropDownData(0, 200, true, true);
  }, [parameters, parentComponentId, debouncedSearchTerm, forceDependency]);

  useEffect(() => {
    if (data.labels && data.labels.length > 0) {
      const firstLabel = optionLabel
        ? data.labels.find((i) => i.sqlStatementColumnName === optionLabel) ??
          data.labels[0]
        : data.labels[0];
      const secondaryLabel = data.name === "IATA Code" ? data.labels[2] : null;

      setPrimaryLabel(firstLabel.sqlStatementColumnName);
      secondaryLabel &&
        setSecondaryLabel(secondaryLabel.sqlStatementColumnName);
    }
  }, [data]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (filterData.length === 0) return;

      if (isOpen) {
        if (event.key === "ArrowDown") {
          setActiveIndex((prevIndex) => (prevIndex + 1) % filterData.length);
        } else if (event.key === "ArrowUp") {
          setActiveIndex(
            (prevIndex) =>
              (prevIndex - 1 + filterData.length) % filterData.length
          );
        } else if (event.key === " ") {
          if (activeIndex >= 0) {
            const option = filterData[activeIndex];
            const isAlreadySelected = filtersOptionsSelected.some((item) =>
              !isStatic
                ? item[primaryLabel] === option[primaryLabel]
                : item.name === option.name
            );

            if (!isAlreadySelected) {
              selectFilterOption(option, activeIndex);
            }
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [filterData, activeIndex, isOpen, filtersOptionsSelected]);

  useEffect(() => {
    if (activeOptionRef.current && containerRef.current) {
      activeOptionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, filtersOptionsSelected]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (typeof filterSearchTerm === "string")
        setDebouncedSearchTerm(filterSearchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterSearchTerm]);

  useEffect(() => {
    setIsOpen(currentIndexTab);
  }, [currentIndexTab]);

  useEffect(() => {
    const handleDeleteWithKey = (e) => {
      if (e.key === "Delete") {
        if (isOpen) {
          clearAllFilters();
        }
      }
    };
    document.addEventListener("keydown", handleDeleteWithKey);

    if (isOpen && menuRef.current) {
      setTimeout(() => {
        const selectWidth = menuRef.current.offsetWidth;
        const dropdownContainer = document.querySelector(
          ".data-basic-filters-cont"
        );
        if (dropdownContainer && !disableMaxWidth) {
          dropdownContainer.style.maxWidth = "15rem";
        }
      }, 10);
    }

    return () => {
      document.removeEventListener("keydown", handleDeleteWithKey);
    };
  }, [isOpen]);

  useEffect(() => {
    if (externalOpening && menuRef.current) {
      setIsOpen(true);
    }
  }, [externalOpening]);

  useEffect(() => {
    if (resetId != null) {
      setFilterOptionsSelected([]);
      showSelectionsInLabel([]);
      if (onAllOptionsSelected) {
        onAllOptionsSelected([]);
      }
    }
  }, [resetId]);

  const nullLabelShown =
    !(visibleOptions.length > 0) && Boolean(data.labelWhenIsNull);

  const DropdownItems = ({ index, style }) => {
    const opt = filterData[index];
    return (
      <div
        ref={activeIndex === index ? activeOptionRef : null}
        className="options"
        style={{
          ...style,
          border: activeIndex === index ? "1px solid var(--green-250)" : "",
          background: activeIndex === index ? "#DBFFEE" : "#FAFAFA",
          width: "100%",
          borderRadius: "0.3rem",
          padding: "0.3rem",
          display: "flex",
          alignItems: "center",
          // gap: "var(--gap)",
          cursor: "pointer",
          transition: "var(--transition)",
        }}
        onClick={() => selectFilterOption(opt, index, false, false)}
      >
        {data.dropdownType === "Multiple Selection" && (
          <Checkbox
            sx={{
              padding: 0,
            }}
            checked={filtersOptionsSelected.some((item) =>
              !isStatic
                ? item[primaryLabel] === opt[primaryLabel]
                : item.name == opt.name
            )}
          />
        )}
        <section
          style={{
            width: data.dropdownType === "Multiple Selection" ? "75%" : "",
          }}
        >
          <p className="ellipsis">
            {isStatic
              ? opt.name
              : opt[primaryLabel] || opt[optionLabel] || "N/A"}
            {secondaryLabel ? ` - ${opt[secondaryLabel]}` : null}
          </p>
        </section>
      </div>
    );
  };

  // this variables are used to calculate the height of dropdowns options and height container , please don't touch!.
  const itemSize =
    parseFloat(getComputedStyle(document.documentElement).fontSize) * 2.2;
  const maxHeight = Math.min(
    filterData.length * itemSize,
    window.innerHeight * 0.3
  );
  return (
    !(disabled && hideWhenDisabled) && (
      <>
        {children ? (
          <div tabIndex={0} onClick={toggleMenu} ref={menuRef} style={{
            outline : "none"
          }}>
            {children}
          </div>
        ) : (
          <button
            disabled={disabled}
            tabIndex={0}
            className={`select ${disabled ? "disabled" : ""}`}
            onClick={toggleMenu}
            ref={menuRef}
            style={{
              border: "none",
              background: "none",
              borderRadius: "var(--input-radius)",
              ...(display1Grid ? { gridColumn: "span 1" } : {}),
              ...(display2Grid ? { gridColumn: "span 2" } : {}),
            }}
          >
            <div id="select-partNumber" className={errorLabel ? "error" : ""}>
              <div
                id="selected-options-container-dropdown"
                className="selected-options-container-dropdown"
              >
                {iconPrefix && <i className={`${iconPrefix} dropdownIcon`}></i>}
                {[
                  ...(visibleOptions.length > 0
                    ? visibleOptions
                    : data.labelWhenIsNull
                    ? [{ [primaryLabel]: data.labelWhenIsNull }]
                    : []),
                ].map((option, idx) => (
                  <span
                    key={idx}
                    className={`${
                      data.dropdownType === "Multiple Selection"
                        ? "selected-option"
                        : "selected-option-singleSelection-dropdown"
                    } ${iconPrefix ? "hasPrefix" : ""}`}
                  >
                    {/* {JSON.stringify(visibleOptions)} */}
                    {/* {isStatic ? option.name : (option[selectionLabel] ?? option[primaryLabel])} */}
                    {isStatic
                      ? option.name
                      : optionsSelectedColumnName
                      ? option[optionsSelectedColumnName]
                      : option[selectionLabel] || option[primaryLabel]}
                  </span>
                ))}
                {hiddenCount > 0 &&
                data.dropdownType === "Multiple Selection" ? (
                  <span className="hidden-count">{`${hiddenCount}+`}</span>
                ) : null}
              </div>
            </div>
            {placeholder && (
              <label
                htmlFor="select-partNumber"
                className={`placeholder-dropdown ${
                  isOpen ||
                  fixedLabel ||
                  nullLabelShown ||
                  visibleOptions.length > 0
                    ? "hidden"
                    : ""
                } ${iconPrefix ? "hasPrefix" : ""}`}
                style={{
                  fontSize:
                    isOpen ||
                    fixedLabel ||
                    nullLabelShown ||
                    visibleOptions.length > 0
                      ? "var(--input-active-label-font-size)"
                      : "",
                  left: fixedLabel ? "50%" : "",
                  transform: fixedLabel
                    ? "TranslateX(-50%) TranslateY(-50%)"
                    : "",
                }}
              >
                {`${required ? "*" : ""}${data.name}`}
              </label>
            )}
            {!hideLabel && (
              <label
                className={`${iconPrefix ? "hasPrefix" : ""}`}
                htmlFor="select-partNumber"
                style={{
                  fontSize:
                    isOpen ||
                    fixedLabel ||
                    nullLabelShown ||
                    visibleOptions.length > 0 ||
                    filtersOptionsSelected.length > 0
                      ? "var(--input-active-label-font-size)"
                      : "",
                  opacity:
                    isOpen ||
                    fixedLabel ||
                    nullLabelShown ||
                    visibleOptions.length > 0 ||
                    filtersOptionsSelected.length > 0
                      ? "1"
                      : "0.5",

                  top:
                    isOpen ||
                    fixedLabel ||
                    nullLabelShown ||
                    visibleOptions.length > 0 ||
                    filtersOptionsSelected.length > 0
                      ? "-0.9em"
                      : "",
                  left: fixedLabel ? "50%" : "",
                  transform: fixedLabel
                    ? "TranslateX(-50%) TranslateY(-50%)"
                    : "",
                }}
              >
                {`${required ? "*" : ""}${ overrideLabel ||data.name}`}
              </label>
            )}

            {errorLabel && !hideRequiredLabel && (
              <i className="error-label">{errorLabel}</i>
            )}
            <KeyboardArrowDown
              sx={{
                position: "absolute",
                right: "0",
                cursor: "pointer",
                transform: isOpen ? "rotate(-180deg)" : "",
              }}
            ></KeyboardArrowDown>
          </button>
        )}
        <Popover
          open={Boolean(isOpen)}
          onClose={() => setIsOpen(false)}
          anchorEl={menuRef.current}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={{
            borderRadius: "0",
          }}
        >
          {
            <section
              className="data-basic-filters-cont"
              style={{
                minWidth: menuRef?.current?.getBoundingClientRect()?.width,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {data.showApplyFilterBtn ? (
                <button
                  className="bg-black-mid txt-white"
                  id="apply-selection-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    applySelection(filtersOptionsSelected);
                    setIsOpen(false);
                  }}
                >
                  Apply selection
                </button>
              ) : null}

              <p className="data-basic-filters-cont-selectedFiltersName ellipsis">
                Select {data.name}
                {!(clearLabel === null) && (
                  <span onClick={() => clearAllFilters()}>
                    {clearLabel || "Clear"}
                  </span>
                )}
              </p>
              {filtersOptionsSelected?.length > 0 &&
              data.dropdownType === "Multiple Selection" ? (
                <section
                  className="filter-options-selected"
                  onClick={(e) => e.stopPropagation()}
                >
                  {filtersOptionsSelected?.length > 0
                    ? filtersOptionsSelected.map((options, index) => {
                        return (
                          <span key={index}>
                            <p
                              className="ellipsis"
                              style={{
                                fontSize: "0.5rem",
                              }}
                            >
                              {options[primaryLabel] || options.name}
                            </p>
                            <Close
                              sx={{
                                fontSize: "var(--p-size)",
                                cursor: "pointer",
                                color: "var(--white)",
                              }}
                              onClick={() => clearOneOptionFilter(options)}
                            ></Close>
                          </span>
                        );
                      })
                    : null}
                </section>
              ) : null}
              <section className="filters-options-cont" ref={containerRef}>
                <div className="search-options-cont-dropdowns">
                  <input
                    type="text"
                    placeholder="Search"
                    autoFocus={isOpen}
                    value={filterSearchTerm}
                    onChange={handleInputChange}
                    onKeyDown={(event) => {
                      if (isOpen && activeIndex !== -1 && event.key === " ") {
                        event.preventDefault();
                      }
                    }}
                  />

                  <img src={searchIcon} alt="" />
                </div>

                {filterData.length > 0 ? (
                  <FixedSizeList
                    height={maxHeight}
                    itemCount={filterData.length}
                    itemSize={itemSize}
                    width={"100%"}
                    onItemsRendered={({ visibleStopIndex }) => {
                      if (visibleStopIndex >= filterData.length - 1) {
                        loadMoreItems();
                      }
                    }}
                  >
                    {DropdownItems}
                  </FixedSizeList>
                ) : (
                  <div className="no-results-label-dropdown">
                    No Results Found
                  </div>
                )}
              </section>
            </section>
          }
        </Popover>
      </>
    )
  );
};

export default Dropdowns;
